import pages from './pages'
import layout from './layout'
import components from './components'

export default { pages, layout, components }
